import React from "react";
import { computed, observable } from "mobx";
import { inject, observer } from "mobx-react";
import { FormikProps, Field, FieldProps } from "formik";
import { IManagementStore } from "@src/Stores/Management/types";
import ClearIcon from "@material-ui/icons/Clear";
import { Values } from "@src/Tools/Values";
import { IValuesStore } from "@src/Stores/Values/types";
import { ApplicationLink } from "@src/Interfaces/Entity/ApplicationLink";
import { Button, Grid, FormHelperText } from "@material-ui/core";
import { STTextField, STInputLabel, STGrid, STButtonsGrid, STFab, STPreviewImage } from "./styles";

interface IProps<T> {
  fieldName: keyof ApplicationLink;
  label: string;
  formikProps: FormikProps<T>;
  management?: IManagementStore;
  values?: IValuesStore;
  imageUrl: string;
}

@inject("management", "values")
@observer
export default class FileField<T> extends React.Component<IProps<T>> {
  @observable file: any;

  handleFileChange = (e: any) => {
    e.persist();

    this.file = URL.createObjectURL(e.currentTarget.files[0]);
    this.props.formikProps.setFieldValue(this.props.fieldName as string, e.currentTarget.files[0]);
  };

  handleResetFile = (e: any) => {
    this.file = null;
    (document.querySelector("#fileInput") as HTMLInputElement).value = null;
    this.props.formikProps.setFieldValue(this.props.fieldName as string, new File([], "reset"));
  };

  handleOpen = (e: any) => {
    const fileNode: any = document.querySelector("#fileInput");
    fileNode.click();
  };

  @computed get previewImageSrc() {
    if (this.file) {
      return this.file;
    }
    return "";
  }

  @computed get isError() {
    return (
      this.props.formikProps.touched[this.props.fieldName] && !!this.props.formikProps.errors[this.props.fieldName]
    );
  }

  componentDidMount() {
    if (this.props.imageUrl) {
      this.file = `${this.props.values.filesPath}${this.props.imageUrl}`;
    }
  }

  render() {
    return (
      <>
        <Field
          name={this.props.fieldName}
          render={({ field }: FieldProps) => (
            <STTextField
              type="file"
              fullWidth
              label={this.props.label}
              onChange={this.handleFileChange}
              id="fileInput"
              inputProps={{
                accept: "image/*",
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
        />

        <STGrid container justify="space-between" alignItems="center">
          <Grid item xs={12}>
            <STInputLabel>{this.props.label}</STInputLabel>
          </Grid>
          <STButtonsGrid item container alignItems="center">
            <Grid item>
              <Button variant="contained" color="primary" onClick={this.handleOpen}>
                {Values.getLocalizationValue("openFile")}
              </Button>
            </Grid>
            {this.file && (
              <Grid item>
                <STFab size="small" onClick={this.handleResetFile}>
                  <ClearIcon />
                </STFab>
              </Grid>
            )}
          </STButtonsGrid>
          <Grid item>
            <STPreviewImage src={this.previewImageSrc} alt="" />
          </Grid>
          <Grid item xs={12}>
            {this.isError && (
              <FormHelperText error={true}>
                {this.props.formikProps.touched[this.props.fieldName] &&
                  this.props.formikProps.errors[this.props.fieldName]}
              </FormHelperText>
            )}
          </Grid>
        </STGrid>
      </>
    );
  }
}
